goog.provide('el8.ptdata.model.note.nonvisitBulletSet');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.note.baseBullet');


// ----------------------
// * NONVISIT BULLET *
// ----------------------
(function() {
    
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.ptdata.model.note.baseBullet);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        this.parent.populate.call(this, spec);
        // All elements receive children, whether they can have
        // them or not
        this.setChildrenSet(
            el8.ptdata.model.note.nonvisitBulletSet(
                { noteId: this.getNoteId(),
                  parentId: this.getId() },
                (spec['children'] || null)
            )
        );
    };

    el8.ptdata.model.note.nonvisitBullet = function(spec) {
        spec.model_class = "NonvisitNoteBullet";
        return new _class(spec);
    };

})();

el8.ptdata.model.note.nonvisitBulletSet = function(setSpec, data) {
    var _set = new el8_EntitySet({
        model: function(spec) {
            if (!spec.noteId) { spec.noteId = setSpec['noteId'] || null; }
            if (!spec.parentId) { spec.parentId = setSpec['parentId'] || null; }
            return el8.ptdata.model.note.nonvisitBullet(spec);
        },
        sortFn: function(a, b) {
            // Sort in sequence
            return a.getSequence() - b.getSequence();
        }
        // no saveFn because it's implemented in nonvisit/main.js inside an AjaxQueue
    });
    _set.asSingleField = function() {
        var separator = separator || ';';
        var all = _set.sorted().map(function(a) { return a.getText(); });
        return all.join(separator+' ');
    };
    _set.create(data);
    return _set;
};


